import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { ROUTER } from '../../config'
import { Container } from '../UI'
import HeaderNav from './header-nav'
import HeaderNavButton from './HeaderNavButton'
import HeaderUserPanel from './HeaderUserPanel'
import styles from './styles.module.scss'

const Header = ({ history }) => {
  const [navState, setNavState] = useState(false)
  const isUserOnline = useSelector(state => state.userOnline)
  const toHomepage = e => {
    e.preventDefault()
    history.push(
      isUserOnline ? '/calendar/tournaments' : '/calendar/tournaments'
    )
  }

  if (window.location.pathname === ROUTER.homepage) return null
  if (window.location.pathname === ROUTER.login) return null
  if (window.location.pathname === ROUTER.signup) return null

  return (
    <header
      className={classNames(styles.header, 'headerBg')}
      data-testid='main-header'
    >
      <Container
        className={styles.container}
        paddingMobile='10px 15px'
        paddingDesktop='20px 15px'
      >
        <a
          href='/calendar/tournaments'
          className={classNames(styles.logo, { [styles.hidden]: navState })}
          onClick={toHomepage}
          data-testid='header-logo'
        >
          <div className='logo logo-sm'>
            <img
              className={classNames(
                styles.logoImage,
                styles.logoImageSm,
                'headerLogoImageSm'
              )}
              alt='passport.gg'
              data-testid='header-logo-sm'
            />
          </div>
          <div className='logo logo-lg'>
            <img
              className={classNames(
                styles.logoImage,
                styles.logoImageLg,
                'headerLogoImageLg'
              )}
              alt='passport.gg'
              data-testid='header-logo-lg'
            />
          </div>
        </a>
        <div
          className={classNames(styles.controls, {
            [styles.navOpen]: navState,
          })}
          data-testid='header-controls'
        >
          <HeaderNav navStatus={navState} />
          <HeaderUserPanel navStatus={navState} />
          <HeaderNavButton navStatus={navState} clickHandler={setNavState} />
        </div>
      </Container>
    </header>
  )
}

export default withRouter(Header)
